import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import "./CTASection.css";

const HERO_BG = "/images/hero_lummo.png"; // servido desde public/images

const CTASection: React.FC = () => {
    const [titleRef, titleVisible] = useScrollAnimation({ threshold: 0.3 });
    const [displayedText, setDisplayedText] = useState("");
    const [showCursor, setShowCursor] = useState(true);
    const fullText = "Ready to Transform Clinical Trials?";

    useEffect(() => {
        if (!titleVisible) return;
        let i = 0;
        const speed = 80;
        const id = setInterval(() => {
            if (i <= fullText.length) {
                setDisplayedText(fullText.slice(0, i));
                i++;
            } else {
                clearInterval(id);
                setShowCursor(false);
            }
        }, speed);
        return () => clearInterval(id);
    }, [titleVisible]);

    return (
        <section className="cta-section">
            {/* Fondo: imagen del hero (inline para evitar problemas del loader) */}
            <div
                className="cta-hero-bg"
                aria-hidden
                style={{ backgroundImage: `url(${HERO_BG})` }}
            />

            <div className="container">
                <div className="cta-content">
                    <h2 ref={titleRef}>
            <span className="gradient-text typewriter-text">
              {displayedText}
                {showCursor && <span className="typewriter-cursor">|</span>}
            </span>
                    </h2>

                    <p className="ink-black">
                        Join the future of clinical research in LATAM. Experience AI-driven
                        infrastructure that turns months into days and accelerates
                        healthcare innovation.
                    </p>

                    <div className="cta-actions">
                        <Link to="/contact#lummo-demo-form" className="primary-cta">
                            <span className="button-text">Book a demo</span>
                        </Link>
                    </div>
                </div>

                <div className="urgency-indicator">
                    <div className="urgency-content">
                        <div className="urgency-text">
                            <h4>Limited Beta Access</h4>
                            <p>Only 50 spots available for Q1 2026. Join the clinical trial revolution.</p>
                        </div>
                        <div className="urgency-counter">
                            <div className="counter-item">
                                <div className="counter-value">47</div>
                                <div className="counter-label">Spots Left</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTASection;
